export default {
    namespaced: true,
    hanwha_dvr: {
      title: "Grabador de Video Hanwha | Grabador de Videos Hanwha",
      name: "nombre",
      ip: "IP",
      user: "Usuario | Usuarios",
      password: "contraseña",
      http_schema: "esquema http(s)",
      rtsp_schema: "esquema rtsp(s)",
      http_port: "puerto http",
      rtsp_port: "puerto rtsp",
      disk_info: "Información del disco",
      network_info: "Información de la Red",
      information: "Información",
      details: "Detalles",
      recording_days: "Días de grabaciones",
      enabled_recording_audit: "Habilitar auditoría de grabación",
      days_recording_audit: "Días de auditoría de grabación",
      model: "Modelo",
      firmware_version: "Versión del firmware",
      build_date: "Fecha de compilación",
      device_type: "Tipo de dispositivo",
      local_ip: "IP local",
      mac_address: "Dirección MAC",
      groups: "Grupo | Grupos",
      groups_permissions: {
        export: {
          name: 'Exportar',
          channels: 'Canales'
        },
        general: {
          record: 'Grabaciones',
          stop_recording: 'Detener grabaciones',
          ptz_control: 'Control PTZ',
          output_control: 'Control remoto de salida de alarma',
          shutdown: 'Apagar'
        },
        menu: {
          camera: {
            name: 'Cámara',
            register: 'Resgistro',
            channel_setup: 'Configuración de canal',
            camera_setup: 'Configuración de cámara',
            camera_password: 'Contraseña de cámara'
          },
          device: {
            name: 'Dispositivo',
            storage_device: 'Dispositivo de Almacenamiento',
            device_format: 'Formato del dispositivo',
            smart: 'S.M.A.R.T',
            monitor: 'Monitor',
            text: 'Texto',
            device: 'Dispositivo',
            event: 'Evento'
          },
          event: {
            name: 'Evento',
            nvr_sensor_detection: 'Detección del sensor Nvr',
            event_setup: 'Configuración del evento',
            onvif_event: 'Evento ONVIF',
            event_rule: 'Regla de Evento',
            event_schedule: 'Calendario de eventos'
          },
          network:{
            name: 'Red',
            ip_port: 'IP y Puerto',
            ip: 'IP',
            port: 'Puerto',
            email: 'Email',
            smtp: 'SMTP',
            event: 'Evento',
            recipient: 'Beneficiario',
            ddns: 'DDNS',
            ip_filtering: 'Filtradi de IP',
            https: 'HTTPS',
            8021: '801.1x' ,
            snmp: 'SNMP',
            dhcp: 'Servidor DHCP',
            p2p: 'P2P'
          },
          record: {
            name: 'Grabación',
            recording_schedule: 'Horario de grabación',
            record_setup: 'Configuración de grabación',
            record_option: 'Opción de grabación'
          },
          system: {
            name: 'Sistema',
            date_time_laguage: 'Fecha/Hora/Idioma',
            system_management: 'Gestión del Sistema',
            product_information: 'Información de producto',
            log: 'Log',
            system_log: 'Log de Sistema',
            event_log: 'Log de Eventos',
            export_log: 'Log de Exportación'
          }
        },
        select_all: 'seleccionar todos',
        search_channel: {
          name: 'Buscar canal',
          channels: 'Canales'
        }
      },
      dateTimeLanguageConfig: 'Configurar fecha/hora/idioma',
      updateAdminUserPassword: 'Cambiar contraseña de administrador',
      deviceInfo: 'Información del dispositivo',
      adminRecord: 'Administrar grabaciones',
      router: 'Router',
      networkConfig: 'Configuración de red',
      auditStartAt: 'Fecha de inicio de auditoría'
    },
};
